import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

import useToken from '../hooks/useToken';
import Skeleton from './skeleton/Skeleton';
import { SanitizedHTML } from '../utils/Helper';
import { API_ENDPOINTS } from '../utils/config';

const PopularPosts = () => {
    const { token } = useToken();

    const [popularPosts, setPopularPosts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        const fetchPopularPosts = async () => {
            try {
                const response = await axios.get(API_ENDPOINTS.POPULAR_GET_ENDPOINT, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${token}`,
                    },
                });       

                if (response.status === 200 && response.data?.items) {
                    setPopularPosts(response.data.items);
                } else {
                    setHasError(true);
                }
            } catch (error) {
                console.error('Error fetching popular posts:', error);
                setHasError(true);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPopularPosts();
    }, [token]);

    if (isLoading) {
        return (
            <div className="common-wrapper mb-4 position-relative">
                <h3 className="mb-4 fw-500 text-uppercase text-4">Popular Posts</h3>
                <ul className="d-flex align-items-start flex-wrap p-0 m-0 popular-post-wrapper">
                    <Skeleton type="popularposts" />
                </ul>
            </div>
        );
    }

    if (hasError) {
        return (
            <div className="common-wrapper mb-4 position-relative">
                <h3 className="mb-4 fw-500 text-uppercase text-4">Popular Posts</h3>
                <p className="text-danger">Failed to load popular posts. Please try again later.</p>
            </div>
        );
    }

    if (popularPosts.length === 0) {
        return null; // or show empty state if needed
    }

    return (
        <div className="common-wrapper mb-4 position-relative">
            <h3 className="mb-4 fw-500 text-uppercase text-4">Popular Posts</h3>
            <ul className="d-flex align-items-start flex-wrap p-0 m-0 popular-post-wrapper">
                {popularPosts.map((post, index) => (
                    <li key={index} className="d-flex align-items-start">
                        {post.featured_image && (
                            <div className="post-side-image side--30 pe-3">
                                <img
                                    src={post.featured_image}
                                    alt={post.title}
                                    className="img-fluid"
                                    width="70"
                                />
                            </div>
                        )}
                        <div className="content_wrap side--70">
                            <h5 className="fw-500 text-start text-3">
                                <Link
                                    to={`/blog/${post.slug}`}
                                    className="text-decoration-none"
                                >
                                    <SanitizedHTML html={post.title} tag="span" />
                                </Link>
                            </h5>
                            <div className="post-meta d-flex align-items-center text-muted fw-500 text-uppercase text-1">
                                <span className="post-author me-2">
                                    <Link
                                        to="/about-me"
                                        className="text-muted text-decoration-none"
                                    >
                                        {post.post_author_name}
                                    </Link>
                                </span>
                                <span className="post-date">{post.post_date}</span>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default PopularPosts;